// The data side of a shade grid (practice-shade-grid.tsx): rows of equal
// squares, empty for the student to shade, or (as a picture to read, 1 Nov
// 2026) with `shaded` squares already filled, row by row from the top left.

export type ShadeGridSpec = {
  type: 'shade_grid';
  rows: number;
  columns: number;
  // How many squares are shown shaded. Always 0 where the grid is answered.
  shaded: number;
};

// More squares than this cannot be tapped on a phone.
const MAX_SIDE = 20;

export function readShadeGrid(
  record: Record<string, unknown>,
): ShadeGridSpec | null {
  const { rows, columns } = record;
  if (
    typeof rows !== 'number' ||
    typeof columns !== 'number' ||
    !Number.isInteger(rows) ||
    !Number.isInteger(columns) ||
    rows < 1 ||
    columns < 1 ||
    rows > MAX_SIDE ||
    columns > MAX_SIDE ||
    rows * columns < 2
  )
    return null;
  const shaded = record.shaded ?? 0;
  if (
    typeof shaded !== 'number' ||
    !Number.isInteger(shaded) ||
    shaded < 0 ||
    shaded > rows * columns
  )
    return null;
  return { type: 'shade_grid', rows, columns, shaded };
}

export function describeShadeGrid(grid: ShadeGridSpec): string {
  const rows = grid.rows === 1 ? '1 row' : `${String(grid.rows)} rows`;
  const shaded =
    grid.shaded === 0
      ? ''
      : grid.shaded === 1
        ? ' 1 square is shaded.'
        : ` ${String(grid.shaded)} squares are shaded.`;
  return `A grid of ${String(grid.rows * grid.columns)} equal squares, in ${rows} of ${String(grid.columns)}.${shaded}`;
}
